module.exports = __webpack_public_path__ + "static/media/en.2caf04a9.svg";